const stock = {
  LIST_NAVIGATION_ITEMS: [{ name: 'stock' }],

  DETAILS_VIEW_ITEMS: [{ name: 'options' }, { name: 'accessories' }, { name: 'service' }, { name: 'summary' }],
  DOM_ID_PREFIX: 'stock_',
};

export default stock;
